<template>
  <div class="businessApplicationDetails">
    <div class="businessApplicationDetails-first">
      <div class="businessApplicationDetails-word">基本信息</div>
      <div :v-model="businessApplicationVO" class="businessApplicationDetail-message">
        <table class="businessApplicationTable" style="width: 100%">
          <tr>
            <td class="tableLabel">编号:</td>
            <td>{{businessApplicationVO.businessApplicationNO}}</td>
            <td class="tableLabel">状态:</td>
            <td style="width: 220px">
              {{businessApplicationVO.itemName}}
            </td>
            <td class="tableLabel">制单时间:</td>
            <td style="width: 220px">{{businessApplicationVO.createdDate}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="businessApplicationDetails-seond">
      <div class="businessApplicationDetails-seond-top">
        <div style="position: absolute; top: 0; left: 0; z-index: 99; width: 100%">
          <div class="businessApplicationDetails-word">价格申请</div>
        </div>
        <!--        <table cellspacing="0" class="table-pj">-->
        <!--          <tr>-->
        <!--            <td>汇总统计</td>-->
        <!--            <td>平均申请价毛利率</td>-->
        <!--            <td style="color: rgb(45, 140, 240)">{{businessApplicationVO.applicationAvgPercent}}%</td>-->
        <!--            <td>平均审核价毛利率</td>-->
        <!--            <td>-->
        <!--              <div>-->
        <!--                营销中心：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve1AvgPercent}}%</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                总监：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve2AvgPercent}}%</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                财务总监：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.finApproveAvgPercent}}%</span>-->
        <!--              </div>-->
        <!--              <div>-->
        <!--                总经理：<span style="color: rgb(45, 140, 240)">{{businessApplicationVO.approve3AvgPercent}}%</span>-->
        <!--              </div>-->
        <!--            </td>-->
        <!--          </tr>-->
        <!--        </table>-->
        <el-table :data="businessApplicationVO.applicationPriceWrapperS" default-expand-all style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.paDetailVOS" style="width: 90%; margin: 0 auto">
                <el-table-column prop="nameValues" label="特性"/>
                <el-table-column label="执行价" prop="executePrice">
                  <template slot-scope="scope">
                    <div v-if="scope.row.priceApplicationType === 20">申请折扣</div>
                    <div v-else>
                      <div v-if="businessApplicationVO.approveStatus === 10">
                        <div v-if="scope.row.standardFloatingPrice === 0">
                          <div v-if="businessApplicationVO.costVisible === true">
                            成本价:
                            <el-input
                                v-model="scope.row.costPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                          </div>
                          <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">
                            销售员:{{scope.row.level1Price}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">区总:{{scope.row.level2Price}}</div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">总监:{{scope.row.level3Price}}</div>
                        </div>
                        <div v-else>
                          <div v-if="businessApplicationVO.costVisible === true">
                            成本价:
                            <el-input
                                v-model="scope.row.costPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <el-input
                                v-model="scope.row.costFloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                          </div>
                          <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">
                            销售员:{{scope.row.level1Price + "/" + scope.row.level1FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">
                            区总:{{scope.row.level2Price + "/" + scope.row.level2FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                            总监:{{scope.row.level3Price + "/" + scope.row.level3FloatingPrice}}
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div v-if="scope.row.standardFloatingPrice === 0">
                          <div v-if="businessApplicationVO.costVisible === true">成本价:{{scope.row.costPrice}}</div>
                          <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">
                            销售员:{{scope.row.level1Price}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">区总:{{scope.row.level2Price}}</div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">总监:{{scope.row.level3Price}}</div>
                        </div>
                        <div v-else>
                          <div v-if="businessApplicationVO.costVisible === true">
                            {{"成本价:" + scope.row.costPrice + "/" + scope.row.costFloatingPrice}}
                          </div>
                          <div :style="businessApplicationVO.applicantPositon === 1 ? 'font-weight: 500' : 'font-weight: bold'">
                            销售员:{{scope.row.level1Price + "/" + scope.row.level1FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1">
                            {{"区总:" + scope.row.level2Price + "/" + scope.row.level2FloatingPrice}}
                          </div>
                          <div v-if="props.row.userPosition !== 1 && props.row.userPosition !== 2">
                            {{"总监:" + scope.row.level3Price + "/" + scope.row.level3FloatingPrice}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="申请价格" prop="applicationPrice">
                  <template slot-scope="scope">
                    <div v-if="scope.row.priceApplicationType === 20">
                      <div v-if="scope.row.floatingPriceType === 20">
                        <div>线缆单价折扣:{{scope.row.price}}%</div>
                        <div>每层加工费:{{scope.row.floatingPrice}}</div>
                      </div>
                      <div v-else>
                        <div>线缆单价折扣:{{scope.row.price}}%</div>
                        <div>加工费折扣:{{scope.row.floatingPrice}}%</div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="scope.row.floatingPrice === 0">
                        {{scope.row.price}}
                        <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                          <div>
                            毛利：
                            <span>
                              {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                            </span>
                          </div>
                          <div>
                            毛利率：
                            <span v-if="scope.row.price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                            </span>
                            %
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        {{scope.row.price + "/" + scope.row.floatingPrice}}
                        <div v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                          <div>
                            毛利：
                            <span>
                              {{parseFloat((scope.row.price - scope.row.costPrice) / 1.13).toFixed(2)}}
                            </span>
                          </div>
                          <div>
                            毛利率：
                            <span v-if="scope.row.price === 0">0</span>
                            <span v-else>
                              {{parseFloat(((scope.row.price - scope.row.costPrice) / scope.row.price) * 100).toFixed(2)}}
                            </span>
                            %
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="380" label="审核价格" prop="mainRepairMan">
                  <template slot-scope="scope">
                    <!--1-->
                    <div>
                      <div v-if="businessApplicationVO.approveStatus === 1">
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div>
                            营销中心:线缆:
                            <el-input 
                                v-model="scope.row.approve1Price" 
                                align="center" 
                                type="number" 
                                min="0" 
                                style="width: 80px"/>
                            %
                          </div>
                          <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                            每层加工费:
                            <el-input 
                                v-model="scope.row.approve1FloatingPrice" 
                                align="center" 
                                type="number" 
                                min="0" 
                                style="width: 80px"/>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            加工费折扣:
                            <el-input 
                                v-model="scope.row.approve1FloatingPrice" 
                                align="center" 
                                type="number" 
                                min="0" 
                                style="width: 80px"/>
                            %
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            营销中心:
                            <el-input
                                v-model="scope.row.approve1Price"
                                align="center"
                                type="number"
                                min="0"
                                style="width: 80px"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            营销中心:
                            <el-input
                                v-model="scope.row.approve1Price"
                                align="center"
                                type="number"
                                min="0"
                                style="width: 80px"
                                @change="getMeanData"/>
                            <el-input
                                v-model="scope.row.approve1FloatingPrice"
                                align="center"
                                type="number"
                                min="0"
                                style="width: 80px"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve1Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div v-if="scope.row.price === scope.row.approve1Price">
                            营销中心:线缆: <span>{{scope.row.approve1Price}}%</span>
                          </div>
                          <div v-else>
                            营销中心:线缆: <span style="color: red">{{scope.row.approve1Price}}%</span>
                          </div>
                          <div v-if="scope.row.floatingPrice === scope.row.approve1FloatingPrice" style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve1FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve1FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve1FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve1FloatingPrice}}%</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            <div v-if="scope.row.price === scope.row.approve1Price">
                              营销中心:
                              <span>{{scope.row.approve1Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              营销中心:
                              <span style="color: red">{{scope.row.approve1Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.price === scope.row.approve1Price">
                              营销中心<span>
                                {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>{{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              营销中心<span style="color: red">
                                {{scope.row.approve1Price + "/" + scope.row.approve1FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve1Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve1Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve1Price - scope.row.costPrice) / scope.row.approve1Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--2-->
                    <div>
                      <div v-if="businessApplicationVO.approveStatus === 2">
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div>
                            总监:线缆:
                            <el-input 
                                v-model="scope.row.approve2Price" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                            %
                          </div>
                          <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                            每层加工费:
                            <el-input 
                                v-model="scope.row.approve2FloatingPrice" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            加工费折扣:
                            <el-input 
                                v-model="scope.row.approve2FloatingPrice" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                            %
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            总监:
                            <el-input
                                v-model="scope.row.approve2Price"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>{{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总监:
                            <el-input
                                v-model="scope.row.approve2Price"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <el-input
                                v-model="scope.row.approve2FloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve2Price === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div v-if="scope.row.price === scope.row.approve2Price">
                            总监:线缆: <span>{{scope.row.approve2Price}}%</span>
                          </div>
                          <div v-else>
                            总监:线缆: <span style="color: red">{{scope.row.approve2Price}}%</span>
                          </div>
                          <div v-if="scope.row.floatingPrice === scope.row.approve2FloatingPrice" style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve2FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve2FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve2FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve2FloatingPrice}}%</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            <div v-if="scope.row.price === scope.row.approve2Price">
                              总监:
                              <span>{{scope.row.approve2Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总监:
                              <span style="color: red">{{scope.row.approve2Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.price === scope.row.approve2Price">
                              总监:
                              <span>
                                {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总监:
                              <span style="color: red">
                                {{scope.row.approve2Price + "/" + scope.row.approve2FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.approve2Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve2Price === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve2Price - scope.row.costPrice) / scope.row.approve2Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--20-->
                    <div>
                      <div v-if="businessApplicationVO.approveStatus === 20">
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div>
                            财务总监:线缆:
                            <el-input 
                                v-model="scope.row.finApprovePrice" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>%
                          </div>
                          <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                            每层加工费:
                            <el-input
                                v-model="scope.row.finApproveFloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"/>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            加工费折扣:
                            <el-input
                                v-model="scope.row.finApproveFloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"/>
                            %
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            财务总监:
                            <el-input
                                v-model="scope.row.finApprovePrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            财务总监:
                            <el-input
                                v-model="scope.row.finApprovePrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <el-input
                                v-model="scope.row.finApproveFloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.finApprovePrice === 0">0</span>
                              <span v-else>
                                {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div v-if="scope.row.price === scope.row.finApprovePrice">
                            财务总监:线缆: <span>{{scope.row.finApprovePrice}}%</span>
                          </div>
                          <div v-else>
                            财务总监:线缆: <span style="color: red">{{scope.row.finApprovePrice}}%</span>
                          </div>
                          <div v-if="scope.row.floatingPrice === scope.row.finApproveFloatingPrice" style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.finApproveFloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.finApproveFloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.finApproveFloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.finApproveFloatingPrice}}%</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            <div v-if="scope.row.price === scope.row.finApprovePrice">
                              财务总监:
                              <span>{{scope.row.finApprovePrice}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              财务总监:
                              <span style="color: red">{{scope.row.finApprovePrice}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.price === scope.row.finApprovePrice">
                              财务总监:
                              <span>
                                {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else> {{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              财务总监:
                              <span style="color: red">
                                {{scope.row.finApprovePrice + "/" + scope.row.finApproveFloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>{{parseFloat((scope.row.finApprovePrice - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.finApprovePrice === 0">0</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.finApprovePrice - scope.row.costPrice) / scope.row.finApprovePrice) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--3-->
                    <div>
                      <div v-if="businessApplicationVO.approveStatus === 3">
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div>
                            总经理:线缆:
                            <el-input 
                                v-model="scope.row.approve3Price" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                            %
                          </div>
                          <div v-if="scope.row.floatingPriceType === 20" style="width: 46%; text-align: left">
                            每层加工费:
                            <el-input 
                                v-model="scope.row.approve3FloatingPrice" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            加工费折扣:
                            <el-input 
                                v-model="scope.row.approve3FloatingPrice" 
                                align="center" 
                                type="number" 
                                style="width: 80px" 
                                min="0"/>
                            %
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            总经理:
                            <el-input
                                v-model="scope.row.approve3Price"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0,</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                          <div v-else>
                            总经理:
                            <el-input
                                v-model="scope.row.approve3Price"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <el-input
                                v-model="scope.row.approve3FloatingPrice"
                                align="center"
                                type="number"
                                style="width: 80px"
                                min="0"
                                @change="getMeanData"/>
                            <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                              /毛利：
                              <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                              毛利率：
                              <span v-if="scope.row.approve3Price === 0">0,</span>
                              <span v-else>
                                {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                              </span>
                              %
                            </span>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div
                            v-if="scope.row.priceApplicationType === 20"
                            style="display: flex; flex-direction: row; justify-content: space-between">
                          <div v-if="scope.row.price === scope.row.approve3Price">
                            总经理:线缆: <span>{{scope.row.approve3Price}}%</span>
                          </div>
                          <div v-else>
                            总经理:线缆: <span style="color: red">{{scope.row.approve3Price}}%</span>
                          </div>
                          <div v-if="scope.row.floatingPrice === scope.row.approve3FloatingPrice" style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span>{{scope.row.approve3FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span>{{scope.row.approve3FloatingPrice}}%</span>
                            </div>
                          </div>
                          <div v-else style="width: 46%; text-align: left">
                            <div v-if="scope.row.floatingPriceType === 20">
                              每层加工费: <span style="color: red">{{scope.row.approve3FloatingPrice}}</span>
                            </div>
                            <div v-else>
                              加工费折扣: <span style="color: red">{{scope.row.approve3FloatingPrice}}%</span>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div v-if="scope.row.floatingPrice === 0">
                            <div v-if="scope.row.price === scope.row.approve3Price">
                              总经理:
                              <span>{{scope.row.approve3Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总经理:
                              <span style="color: red">{{scope.row.approve3Price}}</span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                          <div v-else>
                            <div v-if="scope.row.price === scope.row.approve3Price">
                              总经理:
                              <span>
                                {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                            <div v-else>
                              总经理:
                              <span style="color: red">
                                {{scope.row.approve3Price + "/" + scope.row.approve3FloatingPrice}}
                              </span>
                              <span v-if="businessApplicationVO.costVisible === true" style="color: #ff7e00">
                                /毛利：
                                <span> {{parseFloat((scope.row.approve3Price - scope.row.costPrice) / 1.13).toFixed(2)}}, </span>
                                毛利率：
                                <span v-if="scope.row.approve3Price === 0">0,</span>
                                <span v-else>
                                  {{parseFloat(((scope.row.approve3Price - scope.row.costPrice) / scope.row.approve3Price) * 100).toFixed(2)}}
                                </span>
                                %
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!--                <el-table-column label="备注" prop="note"/>-->
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="productName">
            <template slot-scope="scope">
              <span style="font-weight: bold">{{scope.row.productName}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <handle-detail :bill-id="billId" :bill-type="billType" :sequ-id="sequId"/>
  </div>
</template>

<script>
  import constant from "../../util/constant";
  import HandleDetail from "@/views/workFlow/HandleDetail";

  export default {
    name: "BusinessApplicationPriceApplyPreview",
    components: { HandleDetail },
    props: {
      billId: {
        type: String,
        required: true,
      },
      billType: {
        type: String,
        required: true,
      },
      sequId: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        constant,
        businessApplicationVO: {
          applicationPriceWrapperS: [],
        },
        isHidden: false,
        expands: [],
        ruleValidate: {
          orderNo: { required: true, message: "不能为空", trigger: "blur" },
        },
      };
    },
    watch: {
      params: {
        handler() {
          this.doApprove();
        },
      },
    },
    mounted() {
      this.getData();
      this.expands.push(1);
    },
    methods: {
      getData() {
        this.$emit("loading-status", { loading: true });
        this.$http.get("basic", `sd/ba/getPriceApply/${this.billId}/${this.sequId}`).then((resp) => {
          // console.log(resp);
          this.$emit("loading-status", { loading: false });
          this.businessApplicationVO = resp;
          //this.getMeanData()
          //console.log(this.businessApplicationVO.approveStatus);
        });
      },
      getMeanData() {
        console.log("实时获取平均毛利率");
        let priceSum = 0;
        let costSum = 0;
        let approve1Sum = 0;
        let approve2Sum = 0;
        let approve3Sum = 0;
        let finApproveSum = 0;
        for (let item of this.businessApplicationVO.applicationPriceWrapperS) {
          for (let item1 of item.paDetailVOS) {
            if (item1.price != null && item1.priceApplicationType !== 20) {
              priceSum += parseFloat(item1.price);
            }
            if (item1.costPrice != null && item1.priceApplicationType !== 20) {
              costSum += parseFloat(item1.costPrice);
            }
            if (item1.approve1Price != null && item1.priceApplicationType !== 20) {
              approve1Sum += parseFloat(item1.approve1Price);
            }
            if (item1.approve2Price != null && item1.priceApplicationType !== 20) {
              approve2Sum += parseFloat(item1.approve2Price);
            }
            if (item1.approve3Price != null && item1.priceApplicationType !== 20) {
              console.log(item1.approve3Price);
              approve3Sum += parseFloat(item1.approve3Price);
            }
            if (item1.finApprovePrice != null && item1.priceApplicationType !== 20) {
              finApproveSum += parseFloat(item1.finApprovePrice);
            }
          }
        }
        this.businessApplicationVO.applicationAvgPercent = Math.round(((priceSum - costSum) / priceSum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve1AvgPercent = Math.round(((approve1Sum - costSum) / approve1Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve2AvgPercent = Math.round(((approve2Sum - costSum) / approve2Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.approve3AvgPercent = Math.round(((approve3Sum - costSum) / approve3Sum) * 100 * 100) / 100.0;
        this.businessApplicationVO.finApproveAvgPercent = Math.round(((finApproveSum - costSum) / finApproveSum) * 100 * 100) / 100.0;
        console.log(priceSum, costSum, approve1Sum, approve2Sum, approve3Sum, finApproveSum);
      },
      doApprove() {
        //console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
        let billParam = [];
        console.log(this.businessApplicationVO);
        for (let item of this.businessApplicationVO.applicationPriceWrapperS) {
          for (let item1 of item.paDetailVOS) {
            let object = {};
            if (this.businessApplicationVO.approveStatus === 10) {
              object.costPrice = item1.costPrice;
              object.costFloatingPrice = item1.costFloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 1) {
              object.approve1Price = item1.approve1Price;
              object.approve1FloatingPrice = item1.approve1FloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 2) {
              object.approve2Price = item1.approve2Price;
              object.approve2FloatingPrice = item1.approve2FloatingPrice;
            } else if (this.businessApplicationVO.approveStatus === 20) {
              object.finApprovePrice = item1.finApprovePrice;
              object.finApproveFloatingPrice = item1.finApproveFloatingPrice;
            } else {
              object.approve3Price = item1.approve3Price;
              object.approve3FloatingPrice = item1.approve3FloatingPrice;
            }
            object.padetailID = item1.padetailID;
            billParam.push(object);
          }
        }
        console.log(billParam);
        let params = {
          billId: parseInt(this.billId),
          billType: parseInt(this.billType),
          sequId: parseInt(this.sequId),
          actionType: this.params.actionType,
          approveNote: this.params.approveNote,
          untreadedFlowId: this.params.untreadedFlowId,
          billParam: JSON.stringify(billParam),
        };
        this.$emit("loading-status", { loading: true });
        this.$http
          .post("basic", "applications/doApprove", params)
          .then(() => {
            this.$emit("loading-status", { loading: false });
            this.$message.success("保存成功");
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/workFlow/BusinessApplication",
            });
          })
          .catch(() => {
            this.$emit("loading-status", { loading: false });
          });
      },
    },
  };
</script>

<style lang="scss">
.businessApplicationDetails {
  width: 100%;
  margin: 10px auto;
  .businessApplicationDetails-word {
    width: 98%;
    padding: 10px 1%;
    font-size: 14px;
    background: #f4f7fa;
    border-bottom: 1px solid #dddddd;
  }

  .businessApplicationDetails-first {
    border: 1px solid #dddddd;
    .businessApplicationDetail-message {
      padding: 10px;
      table.businessApplicationTable {
        font-family: verdana, arial, sans-serif;
        font-size: 11px;
        color: #333333;
        border-width: 1px;
        border-color: #dddddd;
        border-collapse: collapse;
      }
      table.businessApplicationTable th {
        text-align: left;
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #dddddd;
        background-color: #d1e6f5;
      }
      table.businessApplicationTable td {
        border-width: 1px;
        padding: 8px;
        border-style: solid;
        border-color: #dddddd;
      }
      .tableLabel {
        width: 10%;
        text-align: right;
        background-color: #d1e6f5;
      }
    }
  }
  .businessApplicationDetails-seond {
    position: relative;
    margin-top: 1%;
    .table-pj {
      width: 100%;
      background: #ffffff;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      margin-top: 35px !important;
      border-top: 1px solid #ebebeb;
      tr {
        td:first-child {
          border-left: none;
        }
        td {
          border-left: 1px solid #ebebeb;
          font-size: 12px;
          text-align: center;
          padding: 5px 0;
          div {
            width: 40%;
            margin: 0 auto 5px auto;
            text-align: left;
          }
          div:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .businessApplicationDetails-seond-bottom {
      .historyBtn {
        button {
          border: none;
          background: #f4f7fa;
          padding: 0;
          margin: 0;
          i {
            color: #2d8cf0;
          }
        }
      }
    }
  }

  .el-table th {
    background: #d1e6f5;
    height: 34px;
  }
  .el-input--mini .el-input__inner {
    padding: 0;
    text-align: center;
  }

  .el-table th.is-leaf,
  .el-table td {
    padding: 5px 0;
  }
  .el-table__header,
  .el-table__body,
  .el-table__footer {
    width: 100% !important;
  }
  @media (min-width: 1300px) and (max-width: 1440px) {
    .businessApplicationDetail {
      width: 1440px;
    }
  }
}
</style>
